import {
  PrinterProfileSchema,
  type PrinterProfile,
} from '@tsagko/label-contracts'
import honeywellPc45t from './profiles/honeywell-pc45t.json'
import honeywellPm45 from './profiles/honeywell-pm45.json'
import satoCl4nx from './profiles/sato-cl4nx.json'
import satoCl6nx from './profiles/sato-cl6nx.json'
import zebraGx420t from './profiles/zebra-gx420t.json'
import zebraZd220 from './profiles/zebra-zd220.json'
import zebraZd420 from './profiles/zebra-zd420.json'
import zebraZd620 from './profiles/zebra-zd620.json'
import zebraZt411 from './profiles/zebra-zt411.json'
import zebraZt411_300 from './profiles/zebra-zt411-300.json'
import zebraZt610 from './profiles/zebra-zt610.json'

const RAW_PROFILES: unknown[] = [
  zebraZd220,
  zebraZd420,
  zebraZd620,
  zebraZt411,
  zebraZt411_300,
  zebraZt610,
  zebraGx420t,
  satoCl4nx,
  satoCl6nx,
  honeywellPm45,
  honeywellPc45t,
]

const PROFILES: PrinterProfile[] = RAW_PROFILES.map(raw =>
  PrinterProfileSchema.parse(raw)
)

export function getPrinterProfiles(): PrinterProfile[] {
  return PROFILES
}

export function getPrinterProfile(id: string): PrinterProfile | undefined {
  return PROFILES.find(p => p.id === id)
}
